import * as React from 'react';
import {IMediaGifProps} from "./IMediaGifProps";
import {IMediagifState} from "./IMediagifState";
import Backend from "../../api/Backend";
import Loader from 'react-loader-spinner'
import no_photo from 'src/assets/images/no_photo.gif'
import {Helmet} from "react-helmet";

class Mediagif extends React.Component<IMediaGifProps, IMediagifState> {

    constructor(props: IMediaGifProps) {
        super(props)

        this.state = {
            data: {},
            loading: true,
            deleted: false
        }
    }

    componentDidMount() {

        this.setState({ loading: true })

        console.log(this.props.match)

        Backend
            .database()
            .ref('gifs/' + this.props.match.params.id)
            .once('value')
            .then((snapshot) => {
                console.log(snapshot.val())
                this.setState({
                    data: snapshot.val(),
                    loading: false,
                    deleted: snapshot.val() ? false: true
                })
            })
            .catch((error) => {
                this.setState({
                    data: undefined,
                    loading: false,
                    deleted: true
                })
            })
    }

    render() {
        const {loading, deleted, data} = this.state

        if (loading) {
            return (
                <Loader type="Plane" color="#f34c71" height={80} width={80}/>
            )
        }

        if (deleted) {
            return (
                <img src={no_photo} alt=""/>
            )
        }

        return (
            <img
                src={data.URL}
                alt={data.title}
                style={{
                    width: 500,
                    height: 400,
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    margin: 'auto'
                }}
            />
        )
    }
}

export default Mediagif



// WEBPACK FOOTER //
// ./src/containers/mediaGif/Mediagif.tsx